import React, { useState } from "react";
import { axiosPost } from "../../utils/AxiosApi";
import { URL } from "../../utils/Constants";
import swal from "sweetalert";
import { Spinner } from "reactstrap";

const RollNumberModal = ({ student, setRollNumberModal, refetchStudents }) => {
  const [rollNumber, setRollNumber] = useState(student?.roll ?? "");
  const [loading, setLoading] = useState(false);
  const handleRollNumberSubmit = (e) => {
    e.preventDefault();

    if (rollNumber === student?.roll) {
      return;
    }

    const params = {
      classRoom: student?.classRoom?.id,
      admission: student?.admissionId,
      yearLevel: student?.yearLevel?.id,
      roll: rollNumber,
    };

    setLoading(true);

    axiosPost(
      URL.updateRollNumber,
      params,
      (response) => {
        if (response.status === 200) {
          setLoading(false);
          setRollNumberModal(false);
          refetchStudents();
          swal("Success", "Roll number updated successfully");
        }
      },
      (error) => {
        setLoading(false);
        swal(
          "Oops",
          error.response.data.message || "Failed to update roll number",
        );
      },
    );
  };

  return (
    <form onSubmit={handleRollNumberSubmit}>
      <div className="student-input">
        <label htmlFor="roll-number">Roll Number</label>
        <input
          type="text"
          name="roll-number"
          id="roll-number"
          value={rollNumber}
          onChange={(e) => setRollNumber(e.target.value)}
        />
      </div>
      <button
        className="primary-btn student-form-btn"
        type="submit"
        disabled={loading}
      >
        {loading ? (
          <Spinner size="sm" color="white" />
        ) : (
          " Add / Edit Roll number"
        )}
      </button>
    </form>
  );
};

export default RollNumberModal;
